import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  serviceType: null, // will be 'maintenance' or 'clean'
  loading: false,
  error: null,
};

const serviceSlice = createSlice({
  name: "service",
  initialState,
  reducers: {
    setServiceType: (state, action) => {
      state.serviceType = action.payload;
    },
    clearServiceType: (state) => {
      state.serviceType = null;
    },
  },
});

export const { setServiceType, clearServiceType } = serviceSlice.actions;
export default serviceSlice.reducer;
